module.exports = __webpack_public_path__ + "1bb89051be7b6c6b7365a351928e22dd.png";